// src/features/dashboard/components/charts/QuestionTypeChart/QuestionTypeChart.jsx
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";

import Chart from "../../../../../components/Chart";
import ChartWrapper from "../../../../../components/common/ChartWrapper/ChartWrapper";
import ChartHeader from "../../../../../components/common/ChartHeader/ChartHeader";
import { transformQuestionDistData } from "../../../utils/chartTransformers";

import "../dashboardCharts.scss";

const PIE_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: "right",
      labels: {
        boxWidth: 20,
        padding: 30,
        usePointStyle: true,
        font: { size: 10 },
      },
    },
    tooltip: {
      callbacks: {
        label: (ctx) => `${ctx.label}: ${ctx.parsed}`,
      },
    },
  },
};

const QuestionTypeChart = () => {
  const { questionDist, questionDistFetching } = useSelector(
    (s) => s.dashboard,
  );
  const chartData = useMemo(
    () => transformQuestionDistData(questionDist),
    [questionDist],
  );
  const isEmpty = !Array.isArray(questionDist) || questionDist.length === 0;

  return (
    <Box className="chart-card animate-card" height="100%">
      <ChartHeader icon={DonutSmallIcon} title="Question Type Distribution" />
      <ChartWrapper
        isLoading={questionDistFetching}
        isEmpty={isEmpty}
        height="350px"
      >
        <Chart type="pie" data={chartData} options={PIE_OPTIONS} />
      </ChartWrapper>
    </Box>
  );
};

export default QuestionTypeChart;
